import { MessageType } from 'enums/MessageType';

import { TurnServerData } from './sharing.reducer';

export const enum SharingActionType {
    DEFAULT = '',
    ReceiveSharingMessage = 'SHARING/RECEIVE_MESSAGE',
    StartViewer = 'SHARING/START_VIEWER',
    StopViewer = 'SHARING/STOP_VIEWER',
    ShowViewer = 'SHARING/SHOW_VIEWER',
    HideViewer = 'SHARING/HIDE_VIEWER',
    CL_CONFIRMED_SHARE_CLIENT_SCREEN = 'SHARING/CL_CONFIRMED_SHARE_CLIENT_SCREEN',
    CL_REQUEST_MEDIA = 'SHARING/CL_REQUEST_MEDIA',
    CL_REJECT_MEDIA = 'SHARING/CL_REJECT_MEDIA',
    CL_CREATE_SESSION = 'SHARING/CL_CREATE_SESSION',
    CL_CREATE_SESSION_TIMEOUT = 'SHARING/CL_CREATE_SESSION_TIMEOUT',
    CL_SESSION_CREATED = 'SHARING/CL_SESSION_CREATED',
    CL_SHARING = 'SHARING/CL_SHARING',
    CL_SHOW_SHARING_REQUEST = 'SHARING/CL_SHOW_SHARING_REQUEST',
    CL_INACTIVATE = 'SHARING/CL_INACTIVATE',
    CL_OPERATOR_REQUESTS_SHARING = 'SHARING/CL_OPERATOR_REQUESTS_SHARING',
}

export type ReceiveSharingMessageAction = ReturnType<typeof receiveSharingMessage>;
export const receiveSharingMessage = (msgType: MessageType) => ({
    type: SharingActionType.ReceiveSharingMessage,
    payload: { msgType },
});

export type StartSharingViewerAction = ReturnType<typeof startSharingViewer>;
export const startSharingViewer = (userId: string, roomId: string) => ({
    type: SharingActionType.StartViewer,
    payload: { userId, roomId },
});

export type StopSharingViewerAction = ReturnType<typeof stopSharingViewer>;
export const stopSharingViewer = () => ({
    type: SharingActionType.StopViewer,
});

export type ShowSharingViewerAction = ReturnType<typeof showSharingViewer>;
export const showSharingViewer = () => ({
    type: SharingActionType.ShowViewer,
});

export type HideSharingViewerAction = ReturnType<typeof hideSharingViewer>;
export const hideSharingViewer = () => ({
    type: SharingActionType.HideViewer,
});

export interface ClConfirmedShareClientScreenAction {
    type: SharingActionType.CL_CONFIRMED_SHARE_CLIENT_SCREEN;
    payload: {
        clConfirmedShareClientScreen: boolean;
    };
}
export interface ClRequestMediaAction {
    type: SharingActionType.CL_REQUEST_MEDIA;
}
export interface ClRejectMediaAction {
    type: SharingActionType.CL_REJECT_MEDIA;
}
export interface ClCreateSessionAction {
    type: SharingActionType.CL_CREATE_SESSION;
}
export interface ClCreateSessionTimeoutAction {
    type: SharingActionType.CL_CREATE_SESSION_TIMEOUT;
}
export interface ClSessionCreatedAction {
    type: SharingActionType.CL_SESSION_CREATED;
    payload: { clUserId: number; clRoomId: string; clTurnData: TurnServerData };
}
export interface ClSharingAction {
    type: SharingActionType.CL_SHARING;
    payload: { clSharing: boolean };
}
export interface ClShowSharingRequestAction {
    type: SharingActionType.CL_SHOW_SHARING_REQUEST;
    payload: {
        clShowSharingRequest: boolean;
    };
}
export interface ClInactivateAction {
    type: SharingActionType.CL_INACTIVATE;
}
export interface ClOperatorRequestsSharingAction {
    type: SharingActionType.CL_OPERATOR_REQUESTS_SHARING;
}
export const sharing = {
    startViewer: startSharingViewer,
    stopViewer: stopSharingViewer,
    showViewer: showSharingViewer,
    hideViewer: hideSharingViewer,

    clConfirmedShareClientScreen: (
        clConfirmedShareClientScreen: boolean,
    ): ClConfirmedShareClientScreenAction => ({
        type: SharingActionType.CL_CONFIRMED_SHARE_CLIENT_SCREEN,
        payload: { clConfirmedShareClientScreen },
    }),
    clRequestMedia: (): ClRequestMediaAction => ({
        type: SharingActionType.CL_REQUEST_MEDIA,
    }),
    clRejectMedia: (): ClRejectMediaAction => ({
        type: SharingActionType.CL_REJECT_MEDIA,
    }),
    clCreateSession: (): ClCreateSessionAction => ({
        type: SharingActionType.CL_CREATE_SESSION,
    }),
    clCreateSessionTimeout: (): ClCreateSessionTimeoutAction => ({
        type: SharingActionType.CL_CREATE_SESSION_TIMEOUT,
    }),
    clSessionCreated: (
        clUserId: number,
        clRoomId: string,
        clTurnData: TurnServerData,
    ): ClSessionCreatedAction => ({
        type: SharingActionType.CL_SESSION_CREATED,
        payload: { clUserId, clRoomId, clTurnData },
    }),
    clSharing: (clSharing: boolean): ClSharingAction => ({
        type: SharingActionType.CL_SHARING,
        payload: { clSharing },
    }),
    clShowSharingRequest: (clShowSharingRequest: boolean): ClShowSharingRequestAction => ({
        type: SharingActionType.CL_SHOW_SHARING_REQUEST,
        payload: { clShowSharingRequest },
    }),
    clInactivate: (): ClInactivateAction => ({
        type: SharingActionType.CL_INACTIVATE,
    }),
    clOperatorRequestsSharing: (): ClOperatorRequestsSharingAction => ({
        type: SharingActionType.CL_OPERATOR_REQUESTS_SHARING,
    }),
};
